<script setup>
import IndexationSitemapTable from '@frontJs/components/tables/projectManagement/seo/IndexationSitemapTable.vue';
import IndexationUrlTable from '@frontJs/components/tables/projectManagement/seo/IndexationUrlTable.vue';
import IndexationTable from '@frontJs/components/tables/projectManagement/seo/tenantReports/IndexationTable.vue';
import ProjectManagementLayout from '@frontJs/layouts/ProjectManagementLayout.vue';
import { Head } from '@inertiajs/vue3';
import TabLayout from '@js/components/tabs/TabLayout.vue';
import PageTitle from '@js/components/titles/PageTitle.vue';
import { h, onMounted, ref } from 'vue';

const { tenant } = defineProps({
    tenant: {
        required: false,
        type: Object,
    },
});

const loading = ref(true);

const data = ref({
    all: 0,
    indexed: 0,
    notIndexed: 0,
});

function updateData() {
    loading.value = true;

    Promise.all([
        axios.post(
            route('front.projectManagement.seo.postIndexationUrlCount', {
                tenant: tenant.id,
            }),
        ),
        axios.post(
            route('front.projectManagement.seo.postIndexationUrlCount', {
                tenant: tenant.id,
            }),
            {
                indexed: true,
            },
        ),
        axios.post(
            route('front.projectManagement.seo.postIndexationUrlCount', {
                tenant: tenant.id,
            }),
            {
                notIndexed: true,
            },
        ),
    ])
        .then(([allData, indexedData, notIndexedData]) => {
            data.value.all = allData.data.count;
            data.value.indexed = indexedData.data.count;
            data.value.notIndexed = notIndexedData.data.count;
        })
        .catch((error) => {
            console.error(error);
        })
        .finally(() => {
            loading.value = false;
        });
}

onMounted(() => {
    if (tenant) {
        updateData();
    }
});

defineOptions({ layout: ProjectManagementLayout });
</script>

<template>
    <Head>
        <title>Indexation - SEO/GEO - Gestion de projet - Datakepler</title>
    </Head>

    <PageTitle :tenant-name="tenant ? tenant.name : undefined">
        Gestion de projet - SEO/GEO - Indexation
    </PageTitle>

    <TabLayout
        v-if="tenant"
        :tabs="{
            url: {
                title: 'URL',
                total: data.all,
                content: h(IndexationUrlTable, { tenant }),
            },
            indexedUrl: {
                title: 'URL indexé',
                total: data.indexed,
                content: h(IndexationUrlTable, { tenant, indexed: true }),
            },
            notIndexedUrl: {
                title: 'URL non indexé',
                total: data.notIndexed,
                content: h(IndexationUrlTable, { tenant, notIndexed: true }),
            },
            sitemap: {
                title: 'Sitemap',
                content: h(IndexationSitemapTable, { tenant }),
            },
        }"
        :loading="loading"
    />
    <IndexationTable v-else />
</template>
